(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("meny", [], factory);
	else if(typeof exports === 'object')
		exports["meny"] = factory();
	else
		root["meny"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 